import { SET_DIRECT_MERCHANTS } from './directMerchants';
import { RESET_STATE } from '../../../../reducer';

export const SET_STATUS_FILTER = 'directMerchants/SET_STATUS_FILTER';
export const SET_SEARCH_FILTER = 'directMerchants/SET_SEARCH_FILTER';
export const CHANGE_PAGE = 'directMerchants/CHANGE_PAGE';
export const TOGGLE_CALENDAR_FILTER = 'directMerchants/TOGGLE_CALENDAR_FILTER';
export const CLEAR_CALENDAR_FILTER = 'directMerchants/CLEAR_CALENDAR_FILTER';
export const SET_CALENDAR_START_FILTER =
  'directMerchants/SET_CALENDAR_START_FILTER';
export const SET_CALENDAR_END_FILTER =
  'directMerchants/SET_CALENDAR_END_FILTER';
export const SET_CALENDAR_SAGA = 'directMerchants/SET_CALENDAR_SAGA';
export const SET_PER_PAGE_FILTER = 'directMerchants/SET_PER_PAGE_FILTER';
export const DOWNLOAD_CSV = 'directMerchants/DOWNLOAD_CSV';
export const SET_PER_PAGE = 'directMerchants/SET_PER_PAGE';

export const setStatusFilter = status => ({
  type: SET_STATUS_FILTER,
  status
});

export const setSearchFilter = searchValue => ({
  type: SET_SEARCH_FILTER,
  searchValue
});

export const changePage = page => ({
  type: CHANGE_PAGE,
  page
});

export const toggleCalendarFilter = () => ({
  type: TOGGLE_CALENDAR_FILTER
});

export const clearCalendarFilter = () => ({
  type: CLEAR_CALENDAR_FILTER
});

export const setCalendarStartFilter = calendarStart => ({
  type: SET_CALENDAR_START_FILTER,
  calendarStart
});

export const setCalendarEndFilter = calendarEnd => ({
  type: SET_CALENDAR_END_FILTER,
  calendarEnd
});

export const setCalendarSaga = () => ({
  type: SET_CALENDAR_SAGA
});

export const downloadCsv = () => ({
  type: DOWNLOAD_CSV
});

export const setPerPage = perPage => ({
  type: SET_PER_PAGE,
  perPage
});

const initialState = {
  status: null,
  search: '',
  perPage: 10,
  currentPage: 1,
  previouslyVisited: [1],
  paginatorTotal: 0,
  calendarFilterState: false,
  startDate: null,
  endDate: null
};

const resetPageState = {
  currentPage: 1,
  previouslyVisited: [1]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STATUS_FILTER:
      return {
        ...state,
        status: action.status,
        ...resetPageState
      };
    case SET_DIRECT_MERCHANTS:
      return {
        ...state,
        paginatorTotal: Math.ceil(
          action.directMerchants.total_users / state.perPage
        )
      };
    case CHANGE_PAGE:
      return {
        ...state,
        currentPage: action.page,
        previouslyVisited: state.previouslyVisited.includes(action.page)
          ? state.previouslyVisited
          : [...state.previouslyVisited, action.page]
      };
    case SET_SEARCH_FILTER:
      return {
        ...state,
        search: action.searchValue,
        ...resetPageState
      };
    case TOGGLE_CALENDAR_FILTER:
      return {
        ...state,
        calendarFilterState: !state.calendarFilterState,
        ...resetPageState
      };
    case SET_CALENDAR_START_FILTER:
      return {
        ...state,
        startDate: action.calendarStart
      };
    case SET_CALENDAR_END_FILTER:
      return {
        ...state,
        endDate: action.calendarEnd,
        ...resetPageState
      };
    case CLEAR_CALENDAR_FILTER:
      return {
        ...state,
        startDate: null,
        endDate: null,
        ...resetPageState
      };
    case SET_PER_PAGE:
      return {
        ...state,
        perPage: action.perPage,
        ...resetPageState
      };
    case RESET_STATE:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
